var PubSub = require("underpub-js");
var ComponentsLoader = require("./ComponentsLoader");
var Pjax = require("pjax");

/**
 * Sitewide
 */
var Sitewide = function(){

  

};

/**
 * Init
 */
Sitewide.prototype.init = function(){

    var self = this;

    this.initEvents();

    var pjax = new Pjax({
        elements: "a", // default is "a[href], form[action]"
        selectors: [".main", "title"],
        switches: {

            ".main": function(oldEl, newEl, options){

                var that = this;

                self.transitionPromise.done(function() {
                    oldEl.innerHTML = newEl.innerHTML;
                    that.onSwitch();
                });

            },

            "title": function(oldEl, newEl, options){

                var that = this;

                self.transitionPromise.done(function() {
                    oldEl.innerHTML = newEl.innerHTML;
                    that.onSwitch();
                });

            },

        },
        cacheBust: false
    })

    
    document.addEventListener('pjax:send', function() {

        self.startTransition();

        PubSub.publish('hideMobileNavOverlay');

        window.pjaxSentTime = new Date().getTime();

    });

    // run the document load events when pjax completes to make sure we're finished
    document.addEventListener('pjax:complete', function() {

        SiteWide.documentOnLoad();

        console.log('pjax complete');

        console.log('pjax sent time: ' + window.pjaxSentTime);

        var currTime = new Date().getTime();

        console.log('curr time: ' + currTime);
        
        if ((currTime - window.pjaxSentTime) > 1000)
        {
            self.endTransition();

            self.scrollToUrlAnchor();
        }
        else
        {

            // set an interval that will end once we've hit our threshold

            var transitionTimerInterval = setInterval(function() {

                var currTime = new Date().getTime();

                if ((currTime - window.pjaxSentTime) > 1000)
                {
                    self.endTransition();
                    window.clearInterval(transitionTimerInterval);

                    self.scrollToUrlAnchor();
                }

            }, 100);

        }

    });

};

/**
 * Init'ing our global events, many of which we publish
 */
Sitewide.prototype.initEvents = function(){

    //
    // Resizing (at the start)
    //
    var windowThrottled = _.throttle(function(e){
        PubSub.publish('resize');
    }, 0, {trailing: false});
    window.addEventListener("resize", windowThrottled, false);

    //
    // Resized Event (at the end)
    //
    var windowResizeDebounce = _.debounce(function(e) {
        PubSub.publish('resized');
    }, 400);
    window.addEventListener("resize", windowResizeDebounce, false);

    // scroll
    var windowScrollThrottled = _.throttle(function(e) {
        console.log('scroll throttled called');
        PubSub.publish('scroll');
    }, 100, {trailing: false});
    window.addEventListener("scroll", windowScrollThrottled, false);

};

Sitewide.prototype.startTransition = function() {

    var self = this;

    $('#transition').removeClass('no-longer-active').addClass('active');

    this.transitionPromise = new $.Deferred();

    window.setTimeout(function() {

        self.transitionPromise.resolve();

    }, 301);

};

Sitewide.prototype.endTransition = function() {
    $('#transition').removeClass('active').addClass('no-longer-active');
};

Sitewide.prototype.scrollToUrlAnchor = function() {
    var currUrlAnchor = location.hash.split('?')[0];

    if (currUrlAnchor != '')
    {
        $(window).scrollTop($(currUrlAnchor).offset().top);
    }
};

module.exports = Sitewide;
